import React from "react";
import { Grid } from "@mui/material";
import "./AboutMe.css";
import aboutMeImg from "../../../../Images/aboutmeimage.jpg";
const AboutMe = () => {
  return (
    <section id="about-me" className="about-me">
      <div className="aboutme-content">
        <Grid container>
          <Grid item xs={12} md={6}>
            <div className="abt-left">
              <h2 className="jsectionHead">About me</h2>
              <div className="abt-left-content">
                <h4 className="jsectionSubHead">Experience</h4>
                <p>
                  Rootdevs (June 2025 - Current)
                  <br /> <b>Software Engineer</b>
                </p>
                <br />
                <p>
                  Bugs Bee It Ltd. (August 2023 - June 2024)
                  <br /> <b>Backend Developer</b>
                </p>
                <br />
                <p>
                  Core Devs Ltd. (December 2021 - February 2024)
                  <br /> <b>Junior Developer</b>
                </p>
              </div>
              <div className="abt-left-content">
                <h2 className="jsectionSubHead">Skills</h2>
                <p>
                  <span className="skill-label">Web:</span> Express.js,
                  socket.IO, web3.js, React, Next.js.
                  <br />
                  <span className="skill-label">DevOps:</span> Docker, nginx,
                  pm2, linux vps.
                  <br />
                  <span className="skill-label">Database:</span> MySQL, MongoDB.
                  <br />
                  <span className="skill-label">Testing:</span> Jest, Vitest,
                  Puppeteer.
                  <br />
                  <span className="skill-label">Bot Frameworks:</span>{" "}
                  DiscordJs, TelegrafJs.
                </p>
              </div>
              <div className="abt-left-content">
                <h2 className="jsectionSubHead">Education</h2>
                <p>
                  Govt. Bangabandhu College pallabi, Dhaka (2020 - 2024)
                  <br /> B.B.A. in Management.
                </p>
              </div>
            </div>
          </Grid>
          <Grid item xs={12} md={6}>
            <div className="abt-right">
              <img src={aboutMeImg} alt="MD. Jayeen Bin Alam" />
            </div>
          </Grid>
        </Grid>
      </div>
    </section>
  );
};

export default AboutMe;
